import React, { Fragment } from 'react';
import Navbar from 'components/@layout/NavBar';
import AppBar from 'components/@layout/AppBar';
import { ModuleProps } from 'types';

export const HeaderBar: React.FC<ModuleProps> = props => {
  return (
    <Fragment>
      <AppBar {...props}></AppBar>
      <Navbar {...props}></Navbar>
    </Fragment>
  );
};

export default HeaderBar;
